import { Stack } from "@mui/material";
import CommunicationSDKDesktop from "../components/desktop/communication-sdk-comp/CommunicationSDKDesktop";

const CommunicationSDK = () => {
  return (
    <Stack gap={2} m={2}>
      <CommunicationSDKDesktop />
    </Stack>
  );
};

export default CommunicationSDK;
